export default __webpack_public_path__ + "static/media/group1.c512351e.jpg";